import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import BakeryDiningIcon from '@mui/icons-material/BakeryDining';
import EngineeringIcon from '@mui/icons-material/Engineering';

export function getToolbarActions({
    table,
    operacao,
    curvaABC,
    natureza,
    custoFilialAtivo,
    handleNovo,
    handleTransformar,
    handleRelatorios,
    handleComandas,
    podeIncluir,
    podeTransformar,
    podeImprimir,
    podeImprimirAnalitico,
    podeImprimirSintetico,
    podeImprimirGerencia,
}) {
    return [
        {
            key: 'novo',
            label: 'Novo',
            tooltip: 'Novo Registro',
            color: 'secondary',
            onClick: handleNovo,
            disabled: !podeIncluir(),
        },
        {
            key: 'transformar',
            label: 'Transformar',
            tooltip: 'Transformar',
            color: 'info',
            onClick:
                !table.getIsSomeRowsSelected() && !table.getIsAllPageRowsSelected() ? undefined : () => handleTransformar(table),
            disabled: !podeTransformar() || (!table.getIsSomeRowsSelected() && !table.getIsAllPageRowsSelected()),
            show: podeTransformar(),
        },
        {
            key: 'imprimir',
            label: `Imprimir`,
            tooltip: `Imprimir conteúdo da tela de ${operacao.descricao} - ${operacao.sigla}`,
            color: 'info',
            onClick: () =>
                handleRelatorios({
                    caminho: 'movimento/imprimir',
                    url: 'imprimir',
                    natureza,
                    auditoria: { habilitada: true, modulo: 'movimento' },
                }),
            disabled: !podeImprimir(),
            show: podeImprimir(),
        },
        {
            key: 'vendas-analitico',
            label: 'Vendas (A)',
            tooltip: 'Relatório de vendas analítico',
            color: 'info',
            onClick: () => handleRelatorios({ caminho: 'movimento', url: 'movimentoVendas', analitico: true }),
            disabled: !podeImprimirAnalitico(),
            show: ['PDV', 'REST'].includes(operacao.sigla) && podeImprimirAnalitico(),
        },
        {
            key: 'vendas-sintetico',
            label: 'Vendas (S)',
            tooltip: 'Relatório de vendas sintético',
            color: 'info',
            onClick: () => handleRelatorios({ caminho: 'movimento', url: 'movimentoVendas', analitico: false }),
            disabled: !podeImprimirSintetico(),
            show: ['PDV', 'REST'].includes(operacao.sigla) && podeImprimirSintetico(),
        },
        {
            key: 'curva-abc',
            label: 'Curva ABC',
            tooltip: 'Relatório de curva ABC no período',
            color: 'info',
            onClick: () => handleRelatorios({ caminho: 'curvaABC', url: 'curvaABC', analitico: false }),
            disabled: !podeImprimirGerencia(),
            show: curvaABC && podeImprimirGerencia(),
        },
        {
            key: 'comandas',
            label: 'Comandas',
            tooltip: 'Emitir multiplas comandas',
            color: 'info',
            onClick:
                !table.getIsSomeRowsSelected() && !table.getIsAllPageRowsSelected() ? undefined : () => handleComandas(table),
            disabled: !podeImprimir() || (!table.getIsSomeRowsSelected() && !table.getIsAllPageRowsSelected()),
            show: operacao.sigla === 'REST',
        },
        {
            key: 'almoço-filial',
            label: 'Almoço (A)',
            tooltip: 'Relatório de almoço analítico',
            color: 'info',
            onClick: () =>
                handleRelatorios({ caminho: 'movimento/almoco/custoFilial', url: 'almocoCustoFilial', analitico: true }),
            disabled: !podeImprimirSintetico(),
            show: operacao.sigla === 'REST' && podeImprimirSintetico() && custoFilialAtivo,
        },
        {
            key: 'almoço-filial-sintetico',
            label: 'Almoço (S)',
            tooltip: 'Relatório de almoço sintético',
            color: 'info',
            onClick: () =>
                handleRelatorios({
                    caminho: 'movimento/almoco/almocoCustoFilialSintetico',
                    url: 'almocoCustoFilialSintetico',
                    analitico: false,
                }),
            disabled: !podeImprimirSintetico(),
            show: operacao.sigla === 'REST' && podeImprimirSintetico() && custoFilialAtivo,
        },
        {
            key: 'entradas-analitico',
            label: `Entradas (${operacao.sigla})`,
            tooltip: 'Relatório de produtos',
            color: 'info',
            onClick: () =>
                handleRelatorios({
                    caminho: 'produtosPorDataPrevista',
                    url: 'produtosPorDataPrevista',
                    analitico: true,
                    natureza,
                }),
            disabled: !podeImprimirAnalitico(),
            show: ['CFR', 'PMP'].includes(operacao.sigla) && podeImprimirAnalitico(),
        },
        /* industria/padaria */
        {
            key: 'industria-pcp',
            label: `PCP`,
            tooltip: 'Relatório de necessidade de Planejamento e Controle de Produção - PCP',
            startIcon: <EngineeringIcon />,
            color: 'info',
            onClick: () =>
                handleRelatorios({
                    caminho: 'industria/pcp',
                    url: 'pcp',
                    analitico: true,
                    natureza,
                }),
            disabled: !podeImprimirAnalitico(),
            show: ['OP'].includes(operacao.sigla) && podeImprimirAnalitico(),
        },
    ];
}
